import * as types from "./types";
import {
  getGeometry,
  postRemove,
  postUploadList,
  getListExport,
  getExportModel,
  getPlatesNumber,
  getMixedGeometryList
} from "./services";

export async function getGeometryAction({ commit }, payload) {
  try {
    return (await getGeometry(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function setStepListAction({ commit }, payload) {
  try {
    commit(types.STEP_LIST, payload);
  } catch (e) {
    console.log(e);
  }
}

export async function remove({ commit }, payload) {
  try {
    await postRemove(payload);
  } catch (e) {
    console.log(e);
  }
}

export async function uploadList({ commit }, payload) {
  try {
    return (await postUploadList(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getListExportAction({ commit }, payload) {
  try {
    return (await getListExport(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getExportModelAction({ commit }) {
  try {
    return (await getExportModel()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getMixedGeometryListAction({ commit },payload) {
  try {
    return (await getMixedGeometryList(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function setMixed({ commit },payload) {
  try {
    commit (types.SET_MIXED,payload);
  } catch (e) {
    console.log(e);
  }
}
export async function setLowPlates({ commit },payload) {
  try {
    commit (types.SET_LOW_PLATE, payload);
  } catch (e) {
    console.log(e);
  }
}
export async function setHighPlates({ commit },payload) {
  try {
    commit (types.SET_HIGH_PLATE, payload);
  } catch (e) {
    console.log(e);
  }
}
export async function setMinPlates({ commit },payload) {
  try {
    commit (types.SET_MIN_PLATE, payload);
  } catch (e) {
    console.log(e);
  }
}
export async function setMaxPlates({ commit },payload) {
  try {
    commit (types.SET_MAX_PLATE, payload);
  } catch (e) {
    console.log(e);
  }
}
export async function setGeometry({ commit },payload) {
  try {
    commit (types.SET_GEOMETRY, payload);
  } catch (e) {
    console.log(e);
  }
}
